import { render, staticRenderFns } from "./sendMessageContent.vue?vue&type=template&id=195bbc4b&scoped=true"
import script from "./sendMessageContent.vue?vue&type=script&lang=js"
export * from "./sendMessageContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195bbc4b",
  null
  
)

export default component.exports